// extracted by mini-css-extract-plugin
export default {"hero":"aqf0Y_wuYvAw6tUSqjDs","background":"DHropJ7ApO4k5IH2cgNW","content":"uzWXFLJqvHegddq2g0jT"};